import { useGetReleaseNotesQuery } from '@/store/api';
/**
 * Platform-services hook for fetching the release notes list.
 *
 * @see src/store/api/cc/releaseNotesApi.ts
 */
export const useGetReleaseNotes = () => {
    const { data, isLoading, isFetching, isError, error, } = useGetReleaseNotesQuery();
    return {
        data,
        isLoading,
        isFetching,
        isError,
        error,
    };
};
